var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hayProblema)?_c('div',{staticClass:"health-core-alert",attrs:{"title":_vm.$t('revisar_procesos_core')},on:{"click":_vm.mostrarDetalle}},[_c('i',{staticClass:"fas fa-heartbeat"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }